/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTopTradersByPnLOptions,
  GetTopTradersByPnLResponses,
} from '../types/GetTopTradersByPnL'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns user PnL ranking for the provided time range. By default only users with allow_copy_trading=true are included. Set all=true to include all users; this requires an admin role.
 * @summary Get top traders by PnL
 * {@link /v1/user/ranking}
 */
export function getTopTradersByPnL<ThrowOnError extends boolean = true>(
  options: Options<GetTopTradersByPnLOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetTopTradersByPnLResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/ranking',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTopTradersByPnLResponses, ThrowOnError>>,
  )
}
